export class DataProtection {
  asisaNewsConsent: boolean
  dataTransfer: boolean
  privacyPolicyConsent: boolean
  thirdPartyTelephoneAdvertising: boolean
  thirdPartyWrittenAdvertising: boolean

  constructor(data: any = {}) {
    this.asisaNewsConsent = data.asisaNewsConsent
    this.dataTransfer = data.dataTransfer
    this.privacyPolicyConsent = data.privacyPolicyConsent
    this.thirdPartyTelephoneAdvertising = data.thirdPartyTelephoneAdvertising
    this.thirdPartyWrittenAdvertising = data.thirdPartyWrittenAdvertising
  }
}
